import { createSelector } from 'reselect';

const customerSelector = state => state.equipment;
const createEquipmentSelector = createSelector(customerSelector, newEquipment => newEquipment);

export default createEquipmentSelector;
